import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LenisProvider from "@/site/LenisProvider";
import Home from "@/pages/Home";
import ForClients from "@/pages/ForClients";
import DeliveryPartners from "@/pages/DeliveryPartners";
import Compliance from "@/pages/Compliance";
import Finance from "@/pages/Finance";
import Opportunities from "@/pages/Opportunities";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Readiness from "@/pages/Readiness";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/for-clients" element={<ForClients />} />
            <Route path="/delivery-partners" element={<DeliveryPartners />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/finance" element={<Finance />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/readiness" element={<Readiness />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </LenisProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
